import { WorkflowType } from '@communities/content-management/domain';

/**
 * Checks if the given workflow type is a Classification workflow
 * @param workflowType - The workflow type to check
 * @returns true if the workflow type is Classification, false otherwise
 */
export function isClassificationWorkflow(workflowType: WorkflowType): boolean {
  return workflowType === WorkflowType.CLASSIFICATION;
}
